import { UserDelegationTargetKindEnum } from '@zaoblako/shared/modules/security/enums/user-delegation-target-kind.enum';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string representations of {@link UserDelegationTargetKindEnum} enumeration values */
export const UserDelegationTargetKindEnumI18n: EnumI18nInterface<UserDelegationTargetKindEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [UserDelegationTargetKindEnum.ACTIVE_BRS_TASKS]: 'Активные заявки на платеж',
  },
  [I18nLocalesEnum.EN_US]: {
    [UserDelegationTargetKindEnum.ACTIVE_BRS_TASKS]: 'Active BRS tasks',
  },
};
